export type LocalJournalingProgress = {
  journalingProgress?: number
  tradingLogId?: string
}

export enum LoadingStatusEnum {
  Idle = 'idle',
  Pending = 'pending',
  Succeeded = 'succeeded',
  Failed = 'failed',
}

export type PeriodRangeDate = [Date | null, Date | null]
export type PeriodRangeString = [string | null, string | null]
